// Effects internal models. Should not be exported.

import { struct, string, eqAny, array, nul, typeOf, nil } from '../../shared/guard';
import { topicIds } from '../constants';

/**
 * CPM common response body subtype.
 */
export const isTopicSettings = struct().required({
  topicId: string,
  state: eqAny(['optInExplicit', 'optInImplicit', 'optOut', 'pendingVerification'] as const)
});

/**
 * CPM TenantEmailSettings response body.
 */
export const isTenantEmailSettings = struct().required({
  topicSettings: array(isTopicSettings)
});

/**
 * CPM EnduserEmailContacts response body.
 */
export const isEnduserEmailContacts = struct().required({
  topicSettings: array(isTopicSettings)
});

/**
 * CPM PhoneEmailContacts response body.
 */
export const isPhoneEmailContacts = struct().required({
  email: string,
  phoneNumber: [string, nul],
  emailTopicSettings: array(isTopicSettings),
  phoneTopicSettings: array(isTopicSettings)
});

/**
 * Two letter country code.
 */
export const isCountryCode = typeOf('string', v => /^[a-z]{2}$/i.test(v));

/**
 * MS Graph user response body.
 */
export const isUserObject = struct().required({
  country: [nil, string],
  usageLocation: [nil, string]
});

/**
 * MS Graph organization response body.
 */
export const isOrgObject = struct().required({
  country: [nil, string],
  countryLetterCode: [nil, string]
});

/**
 * CPM common patch body subtype.
 */
export interface ITopicSettings {
  cultureName: string;
  originalSource: string;
  topicId: typeof topicIds[keyof typeof topicIds];
  state: 'optInExplicit' | 'optOut';
}

/**
 * CPM patch body for EnduserEmailContacts.
 */
export interface IEnduserEmailContactsPatch {
  tenantId: string;
  objectId: string;
  userType: 'endUser';
  topicSettings: ITopicSettings[];
}

/**
 * CPM patch body for EmailPhoneContacts.
 */
export interface IEnduserEmailPhoneContactsPatch {
  country: string;
  email: string;
  phoneNumber: string | null;
  emailTopicSettings: ITopicSettings[];
  phoneTopicSettings: ITopicSettings[];
}
